import { createAction } from 'redux-actions';

export const preloadShowcaseData = createAction('PRELOAD_SHOWCASE_DATA');
export const updateQuery = createAction('UPDATE_SHOWCASE_QUERY', query => ({ query }));
